import './App.css';
import "./style.scss";
import { library } from "@fortawesome/fontawesome-svg-core";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from "./components/home";
import {
  faAnglesDown,
  faAnglesRight,
  faBook,
  faCheckCircle,
  faElevator,
  faRegistered,
  faServer,
  faSpinner,
  faPlus,
  faMinus,
  faCheck
} from "@fortawesome/free-solid-svg-icons";
import Booking from './components/Booking';
import ThankYou from './components/Thankyou';
import GlobalLoader from './components/Global_Loader';

library.add(
  faCheckCircle,
  faAnglesRight,
  faAnglesDown,
  faPlus,
  faMinus,
  faServer,
  faBook,
  faElevator,
  faRegistered,
  faSpinner,
  faCheck
);


function App() {
  return (
    <Router>
      <GlobalLoader />
      <Routes>
        <Route exact path="/" element={<Home />}>
        </Route>
        <Route exact path="/home" element={<Home />}>
        </Route>
        <Route exact path="/booking" element={<Booking />}>
        </Route>
        <Route exact path="/thankyou" element={<ThankYou />}>
        </Route>
      </Routes>
    </Router >
  );
}

export default App;
